import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { AdCampaign, AdCampaignType } from '@/types/ads';

const labelByType: Record<AdCampaignType, string> = {
  VIDEO: 'Video',
  BANNER: 'Imagen',
  TEXT: 'Texto',
  NEWS_TICKER: 'Noticias',
};

const badgeClassByType: Record<AdCampaignType, string> = {
  VIDEO: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  BANNER: 'bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200',
  TEXT: 'bg-green-100 text-green-800 border-green-200',
  NEWS_TICKER: 'bg-red-100 text-red-800 border-red-200',
};

const AdCampaignTypeBadges: React.FC<{ campaign: AdCampaign }> = ({ campaign }) => {
  const { t } = useTranslation();
  const contents = campaign.creatives?.map(c => c.content) ?? [campaign];
  const types = [...new Set(contents.map(c => c.type).filter((type): type is AdCampaignType => !!type))];
  if (!types.length) {
    return <span className="text-sm text-gray-500">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {types.map(type => <span
          key={type}
          className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs border ${badgeClassByType[type]}`}
        >
          {labelByType[type]}
        </span>)}
      {contents.some(c => c.home?.enabled) && <span className="inline-flex items-center rounded-md border border-blue-200 bg-blue-100 px-2 py-0.5 text-xs text-blue-800">{t.homeCampaign.title}</span>}
      {contents.some(c => c.showOnRadio) && <span className="inline-flex items-center rounded-md border border-gray-200 px-2 py-0.5 text-xs">{t.radioCampaign.title}</span>}
    </div>
  );
};

export default AdCampaignTypeBadges;
